document.addEventListener("DOMContentLoaded", function(){
    if(document.querySelector(".ProductForm__AddToCart")){
        document.querySelector(".ProductForm__AddToCart").addEventListener("click", (event)=>{

            var selectedValue = document.querySelector('.ProductForm__SelectedValue');
            if(selectedValue && selectedValue.textContent == ""){
                event.preventDefault();
                event.stopImmediatePropagation()
                event.stopPropagation()
                alert("Please select an option first before clicking add to cart.")
            }
        })
    }
})